/* Lightweight "coming soon" placeholder for routes not built in Phase 0
   (Chat, CRM, the non-Reports expense tabs, Settings, Support). Keeps the IA
   navigable while only Expense > Reports is filled in. */
import { Card } from '../ui';

export function Placeholder({
  title,
  description,
}: {
  title: string;
  description?: string;
}) {
  return (
    <Card className="flex flex-col items-center justify-center gap-2 p-12 text-center">
      <h2 className="font-sans font-semibold text-content-primary text-lg">
        {title}
      </h2>
      <p className="max-w-md font-inter text-content-secondary text-sm">
        {description ??
          'This module is part of the unified Andavo app. Coming in a later phase.'}
      </p>
    </Card>
  );
}
